import React from 'react';
import { Widget } from '../layouts/Widget';
import LayoutInput from '../layouts/LayoutInput.mjs';
import NeuroMessage from '../../../components/NeuroMessage';
import '../../../scss/widgets/TextWidget.scss'; // Import the SCSS file from the new location

/**
 * TextWidget
 * 
 * Displays text content using NeuroMessage, controlled by an appkey.
 * Styling options control the container appearance.
 */

// Basic options
const options = [
  new LayoutInput('text', 'text', 'Text').setWysiwyg().setRequired(),
  new LayoutInput('backgroundColor', 'text', 'Background Color', '#ffffff'),
  new LayoutInput('textColor', 'text', 'Text Color', '#000000'),
  new LayoutInput('fontSize', 'number', 'Font Size (px)', 16),
  new LayoutInput('textAlign', 'dropdown', 'Text Align', 'center', '', ['left', 'center', 'right']),
  new LayoutInput('verticalAlign', 'dropdown', 'Vertical Align', 'center', '', ['top', 'center', 'bottom'])
];

// Advanced styling options
const advancedOptions = [
  new LayoutInput('advancedStyling', 'section', 'Advanced Styling'),
  new LayoutInput('borderRadius', 'number', 'Border Radius (px)', 4),
  new LayoutInput('padding', 'number', 'Padding (px)', 16)
];

// Combine basic and advanced options
const allOptions = [...options, ...advancedOptions];

// eslint-disable-next-line no-unused-vars
const render = (guideData, options, props) => {
  const widget = guideData.questionGroup;
  const page = guideData.page;
  
  const { 
    backgroundColor = '#ffffff', 
    textColor = '#000000',
    fontSize = 16,
    textAlign = 'center',
    verticalAlign = 'center',
    borderRadius = 4,
    padding = 16
  } = options;
  
  const pageKey = page?.key;
  const widgetKey = widget?.key;
  const messageId = pageKey && widgetKey ? `${pageKey}.${widgetKey}` : widgetKey;

  let verticalAlignValue;
  switch (verticalAlign) {
    case 'top':
      verticalAlignValue = 'flex-start';
      break;
    case 'bottom':
      verticalAlignValue = 'flex-end';
      break;
    case 'center':
    default:
      verticalAlignValue = 'center';
  }

  let textAlignContentValue;
  switch (textAlign) {
    case 'left':
      textAlignContentValue = 'flex-start';
      break;
    case 'right':
      textAlignContentValue = 'flex-end';
      break;
    case 'center':
    default:
      textAlignContentValue = 'center';
  }

  const containerStyle = {
    '--text-widget-bg-color': backgroundColor,
    '--text-widget-border-radius': `${borderRadius}px`,
    '--text-widget-padding': `${padding}px`,
    '--text-widget-vertical-align': verticalAlignValue,
  };

  const contentStyle = {
    '--text-widget-text-color': textColor,
    '--text-widget-font-size': `${fontSize}px`,
    '--text-widget-text-align': textAlign, // for the text-align CSS property itself
    '--text-widget-text-horizontal-align': textAlignContentValue, // for justify-content on the flex container
  };

  return (
    <div className="text-widget-container" style={containerStyle}>
      <div className="text-widget-content" style={contentStyle}>
        {messageId ? <NeuroMessage id={messageId} /> : null}
      </div>
    </div>
  );
};

export default new Widget(
  'TextWidget', 
  'Text Display', 
  'Content', 
  render, 
  allOptions,
  {
    minWidth: 1,
    maxWidth: 12,
    minHeight: 1,
    maxHeight: 4,
    defaultWidth: 6,
    defaultHeight: 1
  }
); 